import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import styles from './regEditDropdown.scss';

const RegEditDropdown = (props) => {
    const {
        anchorClass,
        popOverMenuClass,
        alignLeft: forceAlignLeft,
        mobileAlignLeft,
        options,
        onOptionClick,
    } = props;

    const [isMenuShown, setIsMenuShown] = useState(false);
    const [menuPositionParams, setMenuPositionParams] = useState({
        displayMenuBelowAnchor: true,
        alignLeft: forceAlignLeft,
    });
    const wrapperRef = useRef(null);

    const handleAnchorClick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }

        setIsMenuShown(true);
        setMenuPositionParams({
            displayMenuBelowAnchor: showBelow,
            alignLeft: forceAlignLeft,
        });
    };

    const onMenuItemClick = (option) => {
        return (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            onOptionClick(option.id);
        };
    };

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target) && isMenuShown) {
            event.stopPropagation();
            event.preventDefault();
            setIsMenuShown(false);
        }
    }, [wrapperRef, isMenuShown]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchend', handleClickOutside, false);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchend', handleClickOutside, false);
        };
    }, [handleClickOutside]);

    return (
        <div className={`${styles.popOverMenu} ${popOverMenuClass || ''} ml8 mr8 mb8`}>
            <div
                className={`popovermenu-anchor ${anchorClass || ''}`}
                onClick={handleAnchorClick}
            >
                <button
                    type="button"
                    className={`btn btn-primary btn-lg text-uppercase`}
                >
                    Edit Registration <i className={`fas fa-solid fa-caret-down`} />
                </button>
            </div>
            {isMenuShown && (
                <div className="anchor-click-disabler" />
            )}
            <div
                className={`menu-container ${menuPositionParams.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${menuPositionParams.alignLeft ? 'align-left' : 'align-right'} ${mobileAlignLeft} `}
                ref={wrapperRef}
            >
                {isMenuShown && (
                    <div
                        className={`popovermenu-list ${popOverMenuClass || ''} `}
                    >
                        <div
                            id="list"
                            className="menu-list"
                        >
                            {options.map((option) => {
                                return (
                                    <div
                                        id={`item-${option.id}`}
                                        key={option.id}
                                        className="menu-item"
                                        onClick={onMenuItemClick(option)}
                                    >
                                        <div className={`d-flex align-items-center`}>
                                            <span className={`flex-1 mw0 ellipsis`}>
                                                {option.label}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

RegEditDropdown.propTypes = {
    mobileAlignLeft: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    alignLeft: PropTypes.bool,
    onOptionClick: PropTypes.func.isRequired,
    popOverMenuClass: PropTypes.string,
    anchorClass: PropTypes.string,
};

RegEditDropdown.defaultProps = {
    mobileAlignLeft: false,
    alignLeft: false,
    popOverMenuClass: '',
    anchorClass: '',
};

export default RegEditDropdown;
